<template>
	<v-container fluid id="consultas-container" class="d-flex flex-column">
		<v-btn-toggle style="width: 100%;" v-if="!$vuetify.breakpoint.mobile">
			<v-btn class="custom-button-consultas" :class="selectedType === 1 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_additionals'])"
				@click="changeListing(1)">
				<div class="d-flex align-start">
					<v-icon>mdi-view-list-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Proyectos</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Activos</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="selectedType === 2 ? 'selected':''" tile
				@click="changeListing(2)">
				<div class="d-flex align-start">
					<v-icon>mdi-shield-key-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Permisos</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Por defecto</p>
					</div>
				</div>
			</v-btn>
		</v-btn-toggle>
    <v-menu offset-y v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
					rounded
					color="#2D4B95"
					dark
					small
					block
          v-bind="attrs"
          v-on="on"
        >
          Seleccione Opción
        </v-btn>
      </template>
			<div class="d-flex flex-column pa-2 white" style="gap: 5px;">
				<v-btn class="custom-button-consultas" :class="selectedType === 1 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_additionals'])"
					@click="changeListing(1)">
					<div class="d-flex align-start">
						<v-icon>mdi-view-list-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Listado</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Adicionales</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="selectedType === 2 ? 'selected':''" tile
					@click="changeListing(2)">
					<div class="d-flex align-start">
						<v-icon>mdi-shield-key-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Permisos por defecto</p>
						</div>
					</div>
				</v-btn>
			</div>
    </v-menu>
		<div v-if="true">
			<Projects v-if="selectedType === 1" />
			<JobTypePermissions v-if="selectedType === 2" />
		</div>
		<div v-else class="d-flex flex-column align-center justify-center" style="height: 100%;min-height: 300px;">
			<v-icon size="50" color="grey lighten-1">mdi-lock</v-icon>
			<p class="text-center mt-2 mb-0 text--grey">No tienes permisos para acceder a esta sección.</p>
			<p class="text-center caption text--grey">Contacta con el administrador del sistema.</p>
		</div>
	</v-container>
</template>

<script>
import Projects from './Projects'
import JobTypePermissions from './JobTypePermissions'
export default {
	name: 'AdminConfigContainer',
	components: {Projects, JobTypePermissions},
	computed: {
		listing_type(){
			return this.$route.params.listing_type || this.$route.query.listing_type
		}
	},
	watch: {
		// listing_type(newType){
		// 	if(newType){
		// 		this.changeListing(parseInt(newType))
		// 	}
		// }
	},
	data: () => ({
		selectedType: 1
	}),
	mounted(){
		console.log('AdminConfigContainer')
	},
	methods: {
		changeListing(selected){
			this.selectedType = selected
		},
	}
};
</script>

<style scoped>
	.text-primary{color: #2D4B95;}
	.custom-button-consultas.v-btn{
		background-color: white;
		color: #2D4B95;
		opacity: 1!important;
		text-align: left;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon,
	/deep/ .custom-button-consultas.v-btn p{
		color: #2D4B95!important;
		font-size: 13px;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon{font-size: 20px;}
	/deep/ .custom-button-consultas.v-btn:hover .v-icon,
	/deep/ .custom-button-consultas.v-btn:hover p,
	/deep/ .custom-button-consultas.v-btn.selected .v-icon,
	/deep/ .custom-button-consultas.v-btn.selected p{
		color: white!important;;
	}
	.custom-button-consultas.selected,
	.custom-button-consultas:hover{
		background-color: #2D4B95!important
	}
</style>
<style>
	.custom-speed-dial-export .v-speed-dial__list{
		align-items: end;
	}
</style>